export const environment = {
    production: false,
    baseUrl: 'https://qa.assessment.metaecho.com',
    Appkey:'Appkey YXBwS2V5OjNiNWQwNjdjLWEyYWYtNGNkNS1hZGY2LTI2MDE3MmQzYzVlNCxhcHBDb2RlOkNPTU1PTlNfQVBQLkFTU0VTU01FTlRfT1JH',
    XAPPID:'105',
    tldURL:'https://qa.assessment.metaecho.com',
    XAPPKEY:'105265454',
    encryptKey: 'd46749093824a50fd75883031800ef4e632509b0beb01ce1d6ebc283cdb85067ad5450d91aa1c1e200d9f972c3b83a84d410a6d802e6c5605d63ffcad39c6212',
    appContext: "commons_assessment-org",
    respondentContext: "commons_assessment-taker",
    privateAccessKey:'Apikey 118af537-a527-42d8-8492-abb51801a26e',
    defaultConfigScopeValue: "dev.platformcommons.org",
    appCode: 'COMMONS_APP.ASSESSMENT_ORG',
    appConfigVersion: '1.0.0',
    defaultOnwer:'echo'

};

// templateUrl: 'https://pcf-static-public-data.s3.ap-south-1.amazonaws.com/pcf-data-template/Echo_CSV_Upload.xlsx'
